// priority 1...10
// blocker
// emergency

export const PriorityPaleBGPaletteLight: any = {
    1: '#DCF4FD',
    2: '#DCF4FD',
    3: '#E3F1FF',
    4: '#E3F1FF',
    5: '#E2EAFF',
    6: '#FFEEE0',
    7: '#FFE6DE',
    8: '#FFE6DE',
    9: '#FFE6DE',
    10: '#FFE6DE',
    50: '#FCE0E0',
    100: '#FCE0E0'
}
